<aside-navigation />
<map [style.display]="layoutService.hasExtendedLeftPanel() ? 'none' : 'block'"></map>
<div class="global-layout_container" style="pointer-events: all">
  <div class="global-layout_content">
    <router-outlet />
  </div>
</div>
